import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { SeMissingPersonaInfoDocsComponent } from './se-missing-persona-info-docs.component'

const routes: Routes = [{
  path: '',
  component: SeMissingPersonaInfoDocsComponent,
  loadChildren: () => import('@se-po/se-missing-persona-info-feature-missing-persona-info')
      .then(m => m.SeMissingPersonaInfoFeatureMissingPersonaInfoDocsModule)
}]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class SeMissingPersonaInfoDocsRoutingModule {}
